import React from "react";
import { Outlet } from "react-router-dom";

const AuthLayout: React.FC = () => <Outlet />;

export default AuthLayout;
